export default {
  methods: {
    hasWindow() {
      return typeof window !== "undefined" && window !== null
    }
  }
}
